module.exports = __webpack_public_path__ + "static/img/none-app.2a27d2fc.png";